var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('MaterialInfo',{attrs:{"row":_vm.row},on:{"play":_vm.handleVideoClick}}),_c('videoPlayer',{ref:"videoPlayer",attrs:{"controlsList":"nodownload","controls":"","muted":"","videoWidth":"800","videoHeight":"600"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }